import React from "react";
import { useRecoilValue } from "recoil";
import { routeInfo, userCredentials } from "../../recoilState/GlobalState";
import { Routes } from "../../consts/Routes-App";
import { UserCredentialsType } from "../../types/types";

type Props = {
  children: React.ReactNode;
};

export default function ProtectedRoute({ children }: Props): React.ReactNode {
  const credentials = useRecoilValue(userCredentials) as UserCredentialsType;
  const route = useRecoilValue(routeInfo);

  const isVentasRoute = route?.route === Routes.ventas.route;

  if (isVentasRoute) {
    if (
      credentials.rolCod !== "MD" &&
      credentials.rolCod !== "MA" &&
      credentials.rolCod !== "VOP"
    )
      return <></>;
    return children;
  }

  if (credentials.rolCod !== "MD" && credentials.rolCod !== "MA") return <></>;

  return children;
}
